import { combineReducers } from "redux";

import posts from "./posts";
import products from "./products";

export const reducers = combineReducers({ posts, products });
